import { render, staticRenderFns } from "./CarriersDetail.vue?vue&type=template&id=0013d2ae&"
import script from "./CarriersDetail.vue?vue&type=script&lang=js&"
export * from "./CarriersDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports